import { AfterViewInit, ComponentRef, Directive, ElementRef, Input, Renderer2, Type, ViewContainerRef, inject } from '@angular/core';

const HEAD_CELL_LABEL_SELECTOR = '.qima-table-head-cell__label';
const SUFFIX_CLASS = 'app-table__head-cell-suffix';

/**
 * Renders a component right after the label of a `qima-table-head-cell` (before the tooltip and sort icons),
 * because the library head cell exposes no content projection slot.
 */
@Directive({
  standalone: true,
  selector: 'qima-table-head-cell[appTableHeadCellSuffix]',
})
export class TableHeadCellSuffixDirective implements AfterViewInit {
  /**
   * @description
   * Component rendered after the head cell label.
   * @type {Type<unknown> | undefined}
   */
  @Input('appTableHeadCellSuffix')
  public suffixComponent?: Type<unknown>;

  private readonly _elementRef: ElementRef<HTMLElement> = inject(ElementRef);
  private readonly _renderer: Renderer2 = inject(Renderer2);
  private readonly _viewContainerRef: ViewContainerRef = inject(ViewContainerRef);

  public ngAfterViewInit(): void {
    const label: HTMLElement | null = this._elementRef.nativeElement.querySelector(HEAD_CELL_LABEL_SELECTOR);

    if (!this.suffixComponent || !label) {
      return;
    }

    const suffixRef: ComponentRef<unknown> = this._viewContainerRef.createComponent(this.suffixComponent);
    const suffixElement: HTMLElement = suffixRef.location.nativeElement;

    this._renderer.addClass(suffixElement, SUFFIX_CLASS);
    this._renderer.insertBefore(label.parentNode, suffixElement, label.nextSibling);
    suffixRef.changeDetectorRef.detectChanges();
  }
}
